export const validateZenkakuKatakana = (input) => {
  if (!input) {
    return ''
  }

  if (input.match(/^[ァ-ヶー]+$/)) {
    return ''
  }
  return '全角カタカナのみ入力できます'
}

export const validateHankakuAlphabet = (input) => {
  if (!input) {
    return ''
  }
  if (input.match(/^[a-zA-Z]+$/)) {
    return ''
  }

  return '半角アルファベットのみ入力できます'
}

export const validatePhoneNumber = (input) => {
  if (!input) {
    return ''
  }

  if (input.match(/^[0-9+]+$/)) {
    return ''
  }

  return '半角数字と「+」のみ入力できます'
}

// 海外のZipCode対応もあり、半角のみを許容する
export const validateZipCode = (input) => {
  if (!input) {
    return ''
  }

  if (input.match(/^[ -~｡-ﾟ]+$/)) {
    return ''
  }

  return '半角のみ入力できます'
}
